import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Image from 'yoda-core-components/lib/components/Image/Image';
import { imagePath } from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './CardGrid.css';

const cx = classnames.bind(styles);

const CardGrid = (props) => {
    const { giftCards, context } = props;
    const renderGrid = (card) => (
        <div
            className={`${cx('cardContainer')} ${dt(['h-12', 'flex-row', 'flex', 'mr-4', 'ml-2'])}`}
        >
            <Image
                imgClass={dt(['h-10', 'w-10', 'mt-1'])}
                src={imagePath(context, 'icon-giftcard.svg')}
                alt="icon"
                imageRatio={0}
            />
            <p
                className={`${cx('giftCardText')} ${dt([
                    'text-left',
                    'text-base',
                    'font-open-sans-bold',
                    'text-black',
                    'my-auto',
                    'mr-0',
                    'ml-2.5',
                ])}`}
            >
                Gift Card {`**${card.cardNumber.substring(card.cardNumber.length - 4)}`}
            </p>
            <p
                className={`${cx('giftCardBalance')} ${dt([
                    'ml-auto',
                    'text-left',
                    'text-base',
                    'font-open-sans-bold',
                    'text-black',
                    'my-auto',
                    'mr-0',
                ])}`}
            >
                ${parseFloat(card.balance).toFixed(2)}
            </p>
        </div>
    );
    const renderTotal = () => {
        const totalAmount = giftCards
            .map((card) => parseFloat(card.balance))
            .reduce((acc, cur) => acc + cur)
            .toFixed(2);
        return (
            <div
                className={`${cx('total')} ${dt([
                    'bg-white',
                    'flex-row',
                    'flex',
                    'border-r',
                    'border-solid',
                    'border-white',
                    'border-b',
                    'border-t-0',
                    'bolder-l-0',
                ])}`}
            >
                <p
                    className={dt([
                        'my-auto',
                        'mr-0',
                        'ml-4',
                        'text-base',
                        'font-open-sans-bold',
                        'text-black',
                        'leading-10',
                    ])}
                >
                    Total
                </p>
                <p
                    className={`${cx('totalAmount')} ${dt([
                        'my-auto',
                        'mr-4',
                        'ml-auto',
                        'text-base',
                        'font-open-sans-bold',
                        'text-black',
                        'leading-10',
                    ])}`}
                >
                    ${totalAmount}
                </p>
            </div>
        );
    };
    return (
        <div
            className={`${cx('gridContainer')} ${dt([
                'w-full',
                'mt-6',
                'border-solid',
                'border',
                'border-gray-15',
                'rounded-sm',
                'bg-white',
                'flex-col',
                'flex',
            ])}`}
            data-automation-id="at-validated-giftcards-list"
        >
            {giftCards.map((c) => renderGrid(c))}
            {giftCards.length > 1 && renderTotal()}
        </div>
    );
};

CardGrid.propTypes = {
    giftCards: PropTypes.arrayOf(
        PropTypes.shape({
            cardNumber: PropTypes.string.isRequired,
            balance: PropTypes.string.isRequired,
        })
    ).isRequired,
    context: PropTypes.objectOf(PropTypes.object).isRequired,
};

export default CardGrid;
